import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export interface DatabaseEnquiry {
  id: string;
  customer_name: string;
  customer_address: string;
  customer_phone: string;
  customer_mobile: string;
  customer_email: string;
  customer_how_heard: string;
  customer_reason_for_enquiry: string;
  customer_notes: string;
  
  appointment_date: string;
  appointment_time: string;
  appointment_samples_to_take: boolean;
  appointment_description: string;
  
  quote_date_sent: string;
  quote_method: string;
  quote_follow_up_date: string;
  quote_comments: string;
  quote_staff_member: string;
  
  outcome_status: string;
  outcome_notes: string;
  outcome_flag_for_accounts: boolean;
  
  created_at: string;
  updated_at: string;
}

export interface DatabaseSpecification {
  id: string;
  enquiry_id: string;
  item_number: string;
  product: string;
  location: string;
  quantity: number;
  fit: string;
  fixing: string;
  width: number;
  drop: number;
  material: string;
  bottom_rail: string;
  control: string;
  stack: string;
  comments: string;
  created_at: string;
}

export interface DatabaseAttachment {
  id: string;
  enquiry_id: string;
  name: string;
  type: string;
  file_path: string;
  file_size: number;
  created_at: string;
}